import React, { useRef, useState, startTransition } from 'react';
import styles from './index.module.less';
import dynamic from 'next/dynamic';
// import temp from './temp-username.json';
// import temp from './temp-video.json';
import { getReportUsernameDataApi } from '@/lib/service/contont-monitor';
import { useConfigProvider } from '@/context/ConfigProvider';
import ImageSearchComment from './Cpns/ImageSearchComment';
import SectionHow from './MainCpns/SectionHow';

const Header = dynamic(() => import('./Cpns/Header'), {
  ssr: true,
});
const SearchWork = dynamic(() => import('./MainCpns/SearchWork'), {
  ssr: true,
});
const HowSection = dynamic(() => import('./MainCpns/HowSection'), {
  ssr: true,
});
const ContentReverse = dynamic(() => import('./MainCpns/ContentReverse'), {
  ssr: true,
});
const WhatPhotoSearch = dynamic(() => import('./MainCpns/WhatPhotoSearch'), {
  ssr: true,
});
const HowReversePhoto = dynamic(() => import('./MainCpns/HowReversePhoto'), {
  ssr: true,
});
const WhyYouNeed = dynamic(() => import('./MainCpns/WhyYouNeed'), {
  ssr: true,
});
const WhatSearch = dynamic(() => import('./MainCpns/WhatSearch'), {
  ssr: true,
});
const LandingRouters = dynamic(() => import('./MainCpns/LandingRouters'), {
  ssr: true,
});
const SearchHelp = dynamic(() => import('./MainCpns/SearchHelp'), {
  ssr: true,
});
const FreQuestion = dynamic(() => import('./freQuestions/index'), {
  ssr: true,
});
const UserNameResult = dynamic(() => import('./Cpns/UserNameResult'), {
  ssr: false,
});
const SearchBetter = dynamic(() => import('./MainCpns/SearchBetter'), {
  ssr: true,
});
const BottomCta = dynamic(() => import('./MainCpns/BottomCta'), {
  ssr: true,
});

const TwoBlogSec = dynamic(() => import('@/components/Common/TwoBlogSec'), {
  ssr: true,
});
const CustomersTalkUsContent = dynamic(() => import('@/components/Common/CustomersTalkUsContent'), {
  ssr: true,
});
const NewCustomersContent = dynamic(() => import('@/components/Common/NewCustomersContent'), {
  ssr: true,
});

const UserVedioResult = dynamic(() => import('./Cpns/UserVedioResult'), {
  ssr: false,
});
const ImageSearchContainer = dynamic(() => import('./Cpns/ImageSearchContainer'), {
  ssr: false,
});

const Index: React.FC<any> = ({ content, isMain }) => {
  const { isMobile } = useConfigProvider();
  const [tempData, setTempData] = useState<any>({});
  const [someData, setSomeData] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [isSearching, setIsSearching] = useState<boolean>(false);
  const mainRef = useRef<HTMLDivElement>(null); // 创建 ref
  const searchClickRef = useRef<((imageUrl: string) => void) | null>(null); // 存储搜索完成回调
  const removeImageRef = useRef<(() => void) | null>(null); // 存储移除图片回调
  // 图片搜索的 url
  const [imageSearchUrl, setImageSearchUrl] = useState<string>('');

  const [videoDelete, setVideoDelete] = useState<boolean>(false);

  // 🔍 INP 监控：监测并打印 >100ms 的交互延迟
  React.useEffect(() => {
    if (typeof window === 'undefined' || !('PerformanceObserver' in window)) return;

    const observer = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (entry.entryType === 'event' && entry.name === 'pointerdown') {
          const eventEntry = entry as PerformanceEventTiming;
          const duration = eventEntry.duration;
          if (duration > 100) {
            console.warn(`⚠️ INP > 100ms detected: ${duration.toFixed(2)}ms`, {
              entryType: eventEntry.entryType,
              name: eventEntry.name,
              startTime: eventEntry.startTime,
              duration: duration,
              target: eventEntry.target,
            });
          } else {
            console.log(`✅ INP: ${duration.toFixed(2)}ms (Good)`);
          }
        }
      }
    });

    observer.observe({ type: 'event', buffered: true });

    return () => observer.disconnect();
  }, []);

  // CLS 优化：photo/video 搜索的滚动在 handkeCallBackName 中处理
  // 其他搜索类型保持原有的滚动逻辑
  React.useEffect(() => {
    // 跳过 photo/video 类型（已在数据回调中处理滚动）
    if (content.function === 'photo' || content.function === 'video') return;

    // 只在结果渲染完成后滚动（!isSearching && tempData.id）
    if (
      !isSearching &&
      tempData.id &&
      (content.function === 'video' || content.function === 'username' || content.function === '')
    ) {
      const scrollTimeout = setTimeout(() => {
        if (mainRef.current) {
          const elementPosition = mainRef.current.getBoundingClientRect().top + window.scrollY;
          console.log('📜 Scrolling to result, aligning to top of viewport');
          window.scrollTo({
            top: elementPosition, // 结果组件顶部对齐视口顶部
            behavior: 'smooth',
          });
        }
      }, 100); // 延迟 100ms，确保结果完全渲染

      return () => clearTimeout(scrollTimeout);
    }
  }, [isSearching, tempData.id, content.function]);

  const handkeCallBackName = async (value: any, type: string, someData: string) => {
    const { id, unique_id } = value || {};
    console.log('🔍 handkeCallBackName called:', { type, id, unique_id, someData });
    // 如果someData有值，则设置someData //上传视频的切片
    if (someData) {
      setSomeData(someData);
    }
    let times = 0;
    setLoading(true);
    const timer = setInterval(async () => {
      times++;
      const res = await getReportUsernameDataApi(id);
      // 有结果 或者5次都没结果都结束轮询
      if (res.data.complete || (res.data && times > 5)) {
        console.log('✅ Data received, processing...');

        clearInterval(timer);
        setLoading(false);

        // 🎯 CLS 优化：针对 photo/video 搜索的特殊处理
        if (type === 'reverse-photo-search' || type === 'reverse-video-search') {
          console.log(`📸 ${type} result received, applying CLS optimization`);

          // 步骤 1: 先执行瞬间滚动（不使用 smooth，避免滚动动画期间的 CLS）
          if (mainRef.current) {
            const elementPosition = mainRef.current.getBoundingClientRect().top + window.scrollY;
            console.log('📜 Step 1: Instant scroll to result position (behavior: auto)');
            window.scrollTo({
              top: elementPosition,
              behavior: 'auto', // ✅ 瞬间滚动，无动画
            });
          }

          // 步骤 2: 滚动后延迟 100ms，确保视口稳定后再渲染结果
          setTimeout(() => {
            console.log('🎨 Step 2: Rendering result after 100ms delay');

            // ✅ 使用 startTransition 包装状态更新（优化 INP）
            startTransition(() => {
              setTempData({ ...res.data, unique_id });
              setIsSearching(false);
            });
          }, 100);
        } else {
          // 其他搜索类型：保持原有逻辑（由 useEffect 处理滚动）
          startTransition(() => {
            setTempData({ ...res.data, unique_id });
            setIsSearching(false);
          });
        }
      }
    }, 2000);
  };
  const Reset = () => {
    setTempData({});
    setSomeData('');
    if (content.function == 'video') {
      setVideoDelete(true);
    }
  };
  return (
    <div className={styles.container}>
      <Header
        type={content.function}
        content={content}
        callBackName={handkeCallBackName}
        Reset={Reset}
        loading={loading}
        setLoading={setLoading}
        videoDelete={videoDelete}
        setVideoDelete={setVideoDelete}
        isSearching={isSearching}
        setIsSearching={setIsSearching}
        onSearchClick={(imageUrl: string) => searchClickRef.current?.(imageUrl)}
        imageSearchUrl={imageSearchUrl}
        setImageSearchUrl={setImageSearchUrl}
        onRegisterRemoveImage={(fn: () => void) => {
          removeImageRef.current = fn;
        }}
      />
      {(content.function == 'face' || content.function == 'photo') && <ImageSearchComment />}
      <div className={styles.main} ref={mainRef}>
        {(content.function == 'username' || content.function == '') && (
          <div
            className={styles.resultContainer}
            style={{
              minHeight: (() => {
                // 未开始搜索：不占空间
                if (!isSearching && !tempData.id) return '0';
                // 搜索中（骨架屏）：使用固定高度
                if (isSearching) return isMobile ? '600px' : '550px';
                // 有结果：使用固定高度
                if (tempData.total_confirm_clue_num > 0) {
                  return isMobile ? '600px' : '550px';
                }
                // 无结果：使用 auto，避免空白
                return 'auto';
              })(),
              overflow: 'hidden',
            }}
          >
            {isSearching && (
              <div className={styles.usernameSkeleton}>
                <div className={styles.usernameSkeletonHeader}>
                  <div className={styles.usernameSkeletonTitle}></div>
                </div>
                <div className={styles.usernameSkeletonMain}>
                  <div className={styles.usernameSkeletonLeft}>
                    {[1, 2, 3].map((i) => (
                      <div key={i} className={styles.usernameSkeletonAccount}></div>
                    ))}
                  </div>
                  <div className={styles.usernameSkeletonRight}>
                    {[1, 2, 3, 4, 5].map((i) => (
                      <div key={i} className={styles.usernameSkeletonLink}></div>
                    ))}
                  </div>
                </div>
                <div className={styles.usernameSkeletonBottom}>
                  <div className={styles.usernameSkeletonButton}></div>
                  <div className={styles.usernameSkeletonButton}></div>
                </div>
              </div>
            )}
            {!isSearching && tempData.id && <UserNameResult tempData={tempData} Reset={Reset} />}
          </div>
        )}
        {content.function == 'video' && (
          <div
            className={styles.resultContainer}
            style={{
              minHeight: (() => {
                // 未开始检测：不占空间
                if (!isSearching && !tempData.id) return '0';
                // 检测中（骨架屏）：移动端使用较高的固定高度确保 SearchWork 在首屏外，防止 CLS
                if (isSearching) return isMobile ? '900px' : '650px';
                // 有结果：移动端使用较高的固定高度，保持与骨架屏一致，防止布局跳动
                if (tempData.total_confirm_clue_num > 0) {
                  return isMobile ? '900px' : '650px';
                }
                // 无结果：移动端使用 800px 固定高度，避免容器塌陷导致 CLS
                // 说明：NoData 组件实际高度约 665px（图片 300px + 内容 365px）
                // 如果使用 auto，容器会从 900px 塌陷到 665px，导致 SearchWork 被向上推 235px，产生严重 CLS (1.536)
                // 设置 800px 确保：1) 容器高度稳定 2) SearchWork 始终在首屏外 3) 减少空白区域
                return isMobile ? '800px' : '650px';
              })(),
              overflow: 'hidden',
            }}
          >
            {isSearching && (
              <div className={styles.videoSkeleton}>
                <div className={styles.videoSkeletonLeft}></div>
                <div className={styles.videoSkeletonRight}>
                  <div className={styles.videoSkeletonHeader}>
                    <div className={styles.videoSkeletonTitle}></div>
                  </div>
                  <div className={styles.videoSkeletonList}>
                    {Array.from({ length: isMobile ? 8 : 7 }).map((_, i) => (
                      <div key={i} className={styles.videoSkeletonListItem}>
                        <div className={styles.videoSkeletonThumb}></div>
                        <div className={styles.videoSkeletonInfo}>
                          <div className={`${styles.videoSkeletonLine} ${styles.long}`}></div>
                          <div className={`${styles.videoSkeletonLine} ${styles.short}`}></div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            {!isSearching && tempData.id && (
              <UserVedioResult
                tempData={tempData}
                someData={someData}
                Reset={Reset}
                loading={loading}
                setLoading={setLoading}
              />
            )}
          </div>
        )}
        {(content.function == 'face' || content.function == 'photo') && (
          <ImageSearchContainer
            isSearching={isSearching}
            setIsSearching={setIsSearching}
            onRegisterSearchClick={(fn) => {
              searchClickRef.current = fn;
            }}
            imageSearchUrl={imageSearchUrl}
            contentFunction={content.function}
            setImageSearchUrl={setImageSearchUrl}
            onRemoveImage={() => removeImageRef.current?.()}
          />
        )}
        <HowSection content={content} />
        {/* {isMain ? <HowSection content={content} /> : <SearchWork content={content} />} */}
        {isMain ? <WhatSearch content={content} /> : <WhatPhotoSearch content={content} />}
        {!isMain && <HowReversePhoto content={content} />}
        {!isMain && <WhyYouNeed content={content} />}

        {!isMain &&
          (content.function == 'face' || content.function == 'photo') &&
          content.contentInfo['section-how']?.title && <SectionHow content={content} />}

        <LandingRouters content={content} />
        {isMain && <SearchHelp content={content} />}
        <SearchBetter content={content} />
        {/* 改版后用户评价模块不一样了 */}
        {isMain ? (
          <NewCustomersContent content={content.contentInfo['section-testimonial']} />
        ) : (
          <CustomersTalkUsContent content={content.contentInfo['section-testimonial']} />
        )}
        <TwoBlogSec
          blogList={content.blogList}
          topBlogList={content.topBlogList}
          blogTitle={content.contentInfo['section-blog']?.title}
          topBlogTitle={content.contentInfo['section-top-blog']?.title}
        />
        {content.contentInfo['section-faq']?.title && (
          <FreQuestion faqInfo={content?.contentInfo?.['section-faq']} faqList={content?.faqList} />
        )}
      </div>
      <BottomCta content={content} />
    </div>
  );
};

export default Index;
